(() => {
  const root = document.querySelector('[data-campaign-phase]');
  if (!root || root.dataset.shopifyReady === 'true') return;
  root.dataset.shopifyReady = 'true';

  const campaignEnd = Date.parse('2026-09-08T03:59:59.999Z');
  const saleUrl = 'https://shepherdsshelf.com/discount/LABORDAY15?redirect=/collections/all';
  const arrowButtons = [...root.querySelectorAll('button[aria-label^="Previous"],button[aria-label^="Next"]')];
  arrowButtons.forEach((button) => button.addEventListener('click', () => {
    const section = button.closest('section');
    const label = button.getAttribute('aria-label') || '';
    const rail = label.includes('bestsellers')
      ? section?.querySelector('[aria-label^="Best-selling personalized Bibles"]')
      : label.includes('TikTok')
        ? section?.querySelector('[aria-label^="TikTok customer posts"]')
        : section?.querySelector('[aria-label^="Customer Bible gallery"]');
    if (!rail) return;
    const direction = label.startsWith('Previous') ? -1 : 1;
    rail.scrollBy({ left: direction * rail.clientWidth * 0.82, behavior: 'smooth' });
  }));

  const videoModal = document.querySelector('[data-labor-day-video]');
  const videoFrame = videoModal?.querySelector('iframe');
  const videoClose = videoModal?.querySelector('button');
  let videoTrigger = null;
  const closeVideo = () => {
    if (!videoModal || !videoFrame) return;
    videoModal.hidden = true;
    videoFrame.src = 'about:blank';
    document.body.style.overflow = '';
    videoTrigger?.focus();
  };
  root.querySelectorAll('[data-tiktok-id]').forEach((button) => button.addEventListener('click', () => {
    if (!videoModal || !videoFrame) return;
    videoTrigger = button;
    videoFrame.src = `https://www.tiktok.com/player/v1/${button.dataset.tiktokId}?autoplay=1&loop=0&rel=0&native_context_menu=0`;
    videoModal.hidden = false;
    document.body.style.overflow = 'hidden';
    videoClose?.focus();
  }));
  videoClose?.addEventListener('click', closeVideo);
  videoModal?.addEventListener('click', (event) => { if (event.target === videoModal) closeVideo(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && videoModal && !videoModal.hidden) closeVideo(); });

  const gallery = root.querySelector('[aria-label="Customer Bible gallery; scroll horizontally for more"]');
  const pause = root.querySelector('[aria-label="Pause customer gallery"]');
  let galleryPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let resumeAt = 0;
  let previous = performance.now();
  let position = gallery?.scrollLeft || 0;
  const animateGallery = (time) => {
    if (gallery && !galleryPaused && !document.hidden && time >= resumeAt) {
      const items = gallery.children;
      const first = items[0];
      const duplicate = items[items.length / 2];
      const loopPoint = duplicate && first ? duplicate.offsetLeft - first.offsetLeft : 0;
      position += (innerWidth <= 720 ? 12 : 18) * Math.min(time - previous, 64) / 1000;
      if (loopPoint && position >= loopPoint) position -= loopPoint;
      gallery.scrollLeft = position;
    }
    previous = time;
    requestAnimationFrame(animateGallery);
  };
  requestAnimationFrame(animateGallery);
  pause?.addEventListener('change', () => { galleryPaused = pause.checked; });
  gallery?.addEventListener('pointerdown', () => { resumeAt = Infinity; });
  gallery?.addEventListener('pointerup', () => { position = gallery.scrollLeft; resumeAt = performance.now() + 4500; });

  const faqButtons = [...root.querySelectorAll('button[aria-expanded]')];
  faqButtons.forEach((button) => button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    const panel = button.nextElementSibling;
    if (panel) panel.hidden = expanded;
  }));

  const deadlineHeading = [...root.querySelectorAll('h2')].find((heading) => heading.textContent?.includes('weekend ends'));
  if (deadlineHeading) {
    const countdown = document.createElement('div');
    countdown.className = 'ss-labor-day-countdown';
    countdown.setAttribute('role', 'timer');
    countdown.innerHTML = '<div><b>00</b><span>Days</span></div><div><b>00</b><span>Hours</span></div><div><b>00</b><span>Minutes</span></div><div><b>00</b><span>Seconds</span></div>';
    const cta = deadlineHeading.parentElement?.querySelector(`a[href^="${saleUrl}"]`);
    cta?.before(countdown);
    const values = countdown.querySelectorAll('b');
    const tick = () => {
      const seconds = Math.max(0, Math.floor((campaignEnd - Date.now()) / 1000));
      const parts = [Math.floor(seconds / 86400), Math.floor((seconds % 86400) / 3600), Math.floor((seconds % 3600) / 60), seconds % 60];
      values.forEach((value, index) => { value.textContent = String(parts[index]).padStart(2, '0'); });
    };
    tick();
    setInterval(tick, 1000);
  }

  const sticky = document.querySelector('.ss-labor-day-sticky');
  const updateSticky = () => sticky?.classList.toggle('is-visible', scrollY > Math.min(innerHeight * 0.9, 820));
  updateSticky();
  addEventListener('scroll', updateSticky, { passive: true });

  const inbound = new URLSearchParams(location.search);
  root.querySelectorAll('a[href^="https://shepherdsshelf.com"]').forEach((link) => {
    const url = new URL(link.href);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach((key) => {
      const value = inbound.get(key);
      if (value) url.searchParams.set(key, value);
    });
    if (!url.searchParams.has('utm_campaign')) url.searchParams.set('utm_campaign', 'labor_day_2026');
    link.href = url.toString();
  });
})();
